import { render, staticRenderFns } from "./BagPromotion.vue?vue&type=template&id=a4dd4f22&scoped=true"
import script from "./BagPromotion.vue?vue&type=script&lang=js"
export * from "./BagPromotion.vue?vue&type=script&lang=js"
import style0 from "./BagPromotion.vue?vue&type=style&index=0&id=a4dd4f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dd4f22",
  null
  
)

export default component.exports